import { render } from "./TwoFactorPromptModal.vue?vue&type=template&id=3485dcbd&scoped=true&ts=true"
import script from "./TwoFactorPromptModal.vue?vue&type=script&lang=ts"
export * from "./TwoFactorPromptModal.vue?vue&type=script&lang=ts"

import "./TwoFactorPromptModal.vue?vue&type=style&index=0&id=3485dcbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3485dcbd"],['__file',"src/views/components/TwoFactorPromptModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3485dcbd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3485dcbd', __exports__)) {
    api.reload('3485dcbd', __exports__)
  }
  
  module.hot.accept("./TwoFactorPromptModal.vue?vue&type=template&id=3485dcbd&scoped=true&ts=true", () => {
    api.rerender('3485dcbd', render)
  })

}


export default __exports__